import { render } from "./OmaPlayer.vue?vue&type=template&id=b4d7cef6&scoped=true"
import script from "./OmaPlayer.vue?vue&type=script&lang=js"
export * from "./OmaPlayer.vue?vue&type=script&lang=js"

import "./OmaPlayer.vue?vue&type=style&index=0&id=b4d7cef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d7cef6"]])

export default __exports__